import { useEffect } from 'react';
import './Popup.css'
import { isMobile } from 'react-device-detect';

function Popup(props) {
    const { children, closed, setClosed, width, maxWidth, maxHeight, className } = props;
    
    // Lock background scroll when popup is open
    useEffect(() => {
        if (!closed) {
            const originalOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            
            return () => {
                document.body.style.overflow = originalOverflow;
            };
        }
    }, [closed]);
    
    if (closed) {
        return null;
    }
    
    return (
        <div className={`modal ${className}`} onClick={e => e.target === e.currentTarget && setClosed(true)}>
            <div
                className="modal-content"
                style={{
                    width: width ? width : (isMobile ? '88%' : '70%'),
                    maxWidth: maxWidth ? maxWidth : '900px',
                    maxHeight: maxHeight ? maxHeight : (isMobile ? '80vh' : '75vh')
                }}
            >
                <span className="close" onClick={() => setClosed(true)}>&times;</span>
                <div>{children}</div>
            </div>
        </div>
    );
}

export default Popup;
